<template>
  <svg width="79" height="212" viewBox="0 0 79 212" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="Layer_1" clip-path="url(#clip0_2751_1957)">
      <g id="Group">
        <path
          id="Vector"
          d="M29.3317 0L77.1995 40.8664C78.1772 41.703 78.7271 42.8391 78.7271 44.0211V212H66.3764V51.0676C66.3764 48.1738 65.0321 45.4028 62.6337 43.3533L20.5938 7.45328L29.3317 0Z"
          fill="#F5C26F"
        />
        <path
          id="Vector_2"
          d="M65.3219 41.0581C68.4535 43.7293 70.1797 47.2833 70.1797 51.0675V212H74.9306V44.021C74.9306 43.6986 74.7778 43.3916 74.5105 43.1613L26.7725 2.1875L22.9688 5.42672L65.3219 41.0581Z"
          fill="#D4D4D4"
        />
      </g>
      <g id="Group_2">
        <path
          id="Vector_3"
          d="M8.26632 21.2324L49.5807 56.5031C50.4285 57.2246 50.902 58.2071 50.902 59.2203V204.202H40.2469V65.2996C40.2469 62.805 39.0859 60.4101 37.016 58.6446L0.727539 27.6648L8.26632 21.2324Z"
          fill="#F5C26F"
        />
        <path
          id="Vector_4"
          d="M39.3302 56.6645C42.0341 58.975 43.5235 62.0376 43.5235 65.2999V204.203H47.6252V59.2206C47.6252 58.9443 47.4953 58.6756 47.2662 58.4837L6.05879 23.1133L2.77441 25.915L39.3302 56.6645Z"
          fill="#D4D4D4"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_2751_1957">
        <rect width="78" height="212" fill="white" transform="translate(0.727539)" />
      </clipPath>
    </defs>
  </svg>
</template>
